import { render, staticRenderFns } from "./Second_RenewDetail.vue?vue&type=template&id=31b4cb2a&scoped=true&"
import script from "./Second_RenewDetail.vue?vue&type=script&lang=js&"
export * from "./Second_RenewDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b4cb2a",
  null
  
)

export default component.exports